<template>
    <div class="enact-notifications-panel">
        <module-live-table
            v-if="!notificationsDisabled && canShowNotificationsTable"
            config-id="notifications"
            moduleType="Notifications"
            :countryId="defaultCountry"
            hide-top-filters
            hide-title
            cannot-edit
            no-data-found-message="No notifications found"
        />
        <div v-else-if="notificationsDisabled" class="notifications-message">
            You do not have access to Enact notifications.
        </div>
        <div v-else class="notifications-message">
            You currently have no subscriptions, create a subscription to begin.
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue';
import ModuleLiveTable from '@/components/powerMarkets/tables/ModuleLiveTable.vue';
import { useEnactNotifications } from '@/composables/powerMarkets/useEnactNotifications.ts';

const props = defineProps<{
    active: boolean;
}>();

const {
    defaultCountry,
    hasNotificationsTable,
    initialiseNotifications,
    notificationsDisabled,
    subscriptions,
} = useEnactNotifications();

const canShowNotificationsTable = computed<boolean>(() => (
    hasNotificationsTable.value
    || subscriptions.value.order.data.length > 0
));

watch(() => props.active, (active) => {
    if (!active) return;
    initialiseNotifications();
}, { immediate: true });
</script>

<style scoped lang="scss">
.enact-notifications-panel {
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100%;
    min-height: 0;
    overflow-y: hidden;
}

.notifications-message {
    align-self: center;
    justify-self: center;
    color: var(--neutral700);
}

</style>
